/* Real Blends collection page: AJAX add to basket, qty steppers, read more, sort */
(function () {
  if (window.__rbCollectionInit) return;
  window.__rbCollectionInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function updateCartCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-rb-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        // Keep Dawn's own cart bubble in sync if it is on the page
        var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]');
        if (bubble) bubble.textContent = cart.item_count;
      })
      .catch(function () {});
  }

  // Same as Dawn's renderContents, but skips any cart element that isn't on the page
  function renderThemeCart(themeCart, data) {
    try {
      themeCart.classList.remove('is-empty');
      var inner = themeCart.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
      themeCart.productId = data.id;
      themeCart.getSectionsToRender().forEach(function (section) {
        var el = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        var html = data.sections[section.id];
        if (!el || !html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector(section.selector || '.shopify-section');
        if (fresh) el.innerHTML = fresh.innerHTML;
      });
      setTimeout(function () {
        var overlay = themeCart.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', themeCart.close.bind(themeCart));
        if (typeof themeCart.open === 'function') themeCart.open();
      });
    } catch (e) {}
  }

  // Add to basket without leaving the page
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-rb-atc]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var err = form.querySelector('.rb-err');
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var label = btn.getAttribute('data-label') || btn.textContent;

    btn.disabled = true;
    btn.textContent = btn.getAttribute('data-adding') || 'Adding…';
    if (err) err.textContent = '';

    // Dawn's cart drawer / cart notification, if the theme uses one
    var themeCart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = {
      id: Number(idInput.value),
      quantity: Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1)
    };
    if (themeCart && typeof themeCart.getSectionsToRender === 'function') {
      body.sections = themeCart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) throw new Error(data.description || data.message || 'Could not add to basket');
          return data;
        });
      })
      .then(function (data) {
        btn.classList.add('is-added');
        btn.textContent = btn.getAttribute('data-added') || '✓ Added to basket';

        // Redraw and open the theme's cart drawer with the new contents
        if (themeCart && data.sections) renderThemeCart(themeCart, data);
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'rb-collection', productVariantId: body.id, cartData: data });
        }
        document.dispatchEvent(new CustomEvent('rb:cart-added', { detail: { variantId: body.id } }));
        return updateCartCount();
      })
      .catch(function (error) {
        if (err) err.textContent = error.message;
        btn.textContent = label;
      })
      .finally(function () {
        btn.disabled = false;
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.textContent = label;
        }, 2500);
      });
  });

  // Qty − / + buttons, basket link, gallery thumbnails, read more
  document.addEventListener('click', function (e) {
    // Basket link: load the latest cart into the slide-out cart, then open it
    var cartLink = e.target.closest('[data-rb-cart-link]');
    if (cartLink) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.getSectionsToRender !== 'function') return; // no drawer: go to the cart page
      e.preventDefault();
      var ids = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      fetch(root + '?sections=' + encodeURIComponent(ids))
        .then(function (r) { return r.json(); })
        .then(function (sections) { renderThemeCart(drawer, { sections: sections }); })
        .catch(function () { if (typeof drawer.open === 'function') drawer.open(cartLink); });
      return;
    }

    var thumb = e.target.closest('[data-rb-thumb]');
    if (thumb) {
      var main = document.querySelector('.rb-main-img');
      if (main) {
        main.src = thumb.getAttribute('data-src');
        main.srcset = thumb.getAttribute('data-srcset') || '';
        main.alt = thumb.getAttribute('data-alt') || main.alt;
      }
      document.querySelectorAll('[data-rb-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      return;
    }

    var step = e.target.closest('[data-rb-step]');
    if (step) {
      var input = step.parentElement.querySelector('input');
      var next = (parseInt(input.value, 10) || 1) + Number(step.getAttribute('data-rb-step'));
      input.value = Math.min(Math.max(next, 1), 99);
      return;
    }

    var more = e.target.closest('[data-rb-more]');
    if (more) {
      var desc = document.getElementById(more.getAttribute('aria-controls'));
      var open = desc.classList.toggle('is-open');
      more.setAttribute('aria-expanded', open);
      more.textContent = open ? more.getAttribute('data-less') : more.getAttribute('data-more');
    }
  });

  // Variant dropdown updates the price shown on the card
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-rb-variant]');
    if (select) {
      var opt = select.options[select.selectedIndex];
      var form = select.closest('form');
      var price = form.querySelector('[data-rb-price]');
      if (price && opt.getAttribute('data-price')) price.innerHTML = opt.getAttribute('data-price');
      var btn = form.querySelector('[type="submit"]');
      var available = opt.getAttribute('data-available') === 'true';
      btn.disabled = !available;
      btn.textContent = available ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout');
      return;
    }

    var sort = e.target.closest('[data-rb-sort]');
    if (sort) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
  });

  // Hide the "Read more" link when the description already fits
  function checkDescriptions() {
    document.querySelectorAll('[data-rb-more]').forEach(function (btn) {
      var desc = document.getElementById(btn.getAttribute('aria-controls'));
      if (desc && !desc.classList.contains('is-open') && desc.scrollHeight <= desc.clientHeight + 2) {
        btn.hidden = true;
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', checkDescriptions);
  else checkDescriptions();
})();
